import './App.css';
import Feed from './Feed';

function App() {
  return (
    <div className="App">
        <h1>Feed</h1>
        <Feed/>
    </div>
  );
}

export default App;
